module.exports = __webpack_public_path__ + "img/man-shrugging.7b8e76d3.png";